// quiron/frontend/src/components/QuizPlayer.js

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { submitQuiz } from '../api';
import styles from './QuizPlayer.module.css'; // Crie um CSS para este componente

const QuizPlayer = ({ questions, mode, onFinish }) => {
  const { t } = useTranslation();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [showFeedback, setShowFeedback] = useState(false);
  const [score, setScore] = useState(null);

  const objectiveQuestions = questions.questionario_objetivo || [];
  const currentQuestion = objectiveQuestions[currentQuestionIndex];

  const handleAnswerSelect = (answerIndex) => {
    if (showFeedback) return; // Impede a troca de resposta após o feedback ser mostrado
    setUserAnswers(prev => ({ ...prev, [currentQuestionIndex]: answerIndex }));
    if (mode === 'study' || mode === 'challenge') { // Mostra feedback para ambos os modos de estudo
      setShowFeedback(true);
    }
  };

  const handleNextQuestion = () => {
    setShowFeedback(false);
    if (currentQuestionIndex < objectiveQuestions.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
    } else {
      // Fim do quiz
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
      // Lógica para calcular a pontuação e submeter
      // const finalScore = calculateScore();
      // await submitQuiz({ ... });
      // setScore(finalScore);
      alert("Quiz finalizado!"); // Placeholder
      onFinish();
  };

  if (score !== null) {
      return <div className={styles.finalScore}>{t('yourFinalScoreIs', { score })}</div>;
  }

  if (!currentQuestion) {
    return <div className={styles.loading}>{t('loadingQuestions')}</div>;
  }

  const isAnswered = userAnswers[currentQuestionIndex] !== undefined;

  return (
    <div className={styles.quizContainer}>
      <div className={styles.questionHeader}>
        <h3 className={styles.questionText}>{currentQuestion.pergunta}</h3>
        <span className={styles.questionCounter}>{`${currentQuestionIndex + 1} / ${objectiveQuestions.length}`}</span>
      </div>
      <ul className={styles.answerList}>
        {currentQuestion.alternativas.map((alt, index) => {
          let itemClass = styles.answerItem;
          if (showFeedback) {
            if (index === currentQuestion.resposta_correta) {
              itemClass += ` ${styles.correct}`;
            } else if (index === userAnswers[currentQuestionIndex]) {
              itemClass += ` ${styles.incorrect}`;
            }
          } else if (isAnswered && userAnswers[currentQuestionIndex] === index) {
            itemClass += ` ${styles.selected}`;
          }

          return (
            <li key={index} className={itemClass} onClick={() => handleAnswerSelect(index)}>
              <span className={styles.answerLetter}>{String.fromCharCode(65 + index)}</span>
              <span className={styles.answerText}>{alt}</span>
            </li>
          );
        })}
      </ul>
      
      <div className={styles.quizFooter}>
        {showFeedback && (
          <div className={styles.feedbackMessage}>
            {userAnswers[currentQuestionIndex] === currentQuestion.resposta_correta ? t('correct') : t('incorrect')}
          </div>
        )}
        <button onClick={handleNextQuestion} className={styles.nextButton} disabled={!isAnswered}>
          {currentQuestionIndex === objectiveQuestions.length - 1 ? t('finishQuiz') : t('nextQuestion')}
        </button>
      </div>
    </div>
  );
};

export default QuizPlayer;